import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import FHIRPractitioner from '../FhirComponents/template/PractitionerNew/fhirPractitioner';
import {
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
} from '../MainUIFrame/constants';
import { useMainFrameDispatch } from '../MainUIFrame/MainFrame';

const CreatePractitionerDialog = props => {
  const dispatch = useMainFrameDispatch();
  const [identityUpload, setIdentityUpload] = useState(false);
  const [insuranceUpload, setInsuranceUpload] = useState(false);
  const practitionerEditPageRef = useRef(null);

  const handleClose = () => {
    props.setDialog({
      open: false,
      data: {},
    });
  };

  const handleOnCallback = ({ name, payload } = {}) => {
    if (name === 'identityUpload') {
      setIdentityUpload(payload);
      if (payload) {
        dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
      } else {
        dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      }
    }

    if (name === 'insuranceUpload') {
      setInsuranceUpload(payload);
      if (payload) {
        dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
      } else {
        dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      }
    }
  };

  return (
    <>
      <Dialog
        sx={{ zIndex: theme => theme.zIndex.modal + 1 }}
        maxWidth="lg"
        open={props?.dialog?.open}
        onClose={handleClose}
      >
        <DialogTitle>Create a practitioner to continue</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FHIRPractitioner
              ref={practitionerEditPageRef}
              practitionerObject={props.dialog?.data}
              handleOnCallback={handleOnCallback}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              // practitionerEditPageRef.current.
            }}
          >
            Create and continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreatePractitionerDialog;
